module.exports = __webpack_public_path__ + "img/tuihuo5_h5.d2b6877.jpg";